import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            GET /spaces/{"{"}spaceId{"}"}/ideas
          </h1>
        </div>
        <p>
          Return a JSON object that lists the posts (ideas) in the specified
          space. Note: Use <em>nextPageUrl</em> and <em>prevPageUrl</em> from
          the response data for query{" "}
          <Link to="/guides/pagination">pagination</Link>.
        </p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>spaceId</td>
                <td>Unique identifier of the space.</td>
                <td>path</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>size</td>
                <td>Number of messages to return.</td>
                <td>query</td>
                <td>No</td>
                <td>20</td>
              </tr>
              <tr>
                <td>page</td>
                <td>Page number of response data.</td>
                <td>query</td>
                <td>No</td>
                <td>1</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>PERM_TOPIC_UPDATE</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET https://spacesapis.avayacloud.com/api/spaces/{"{"}spaceId{"}"}/ideas
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
     {`{
   "data":[
      {
         "_id":"5f04bc16567f85f8f273edd5",
         "sender":{
            "_id":"5eeb4e49aa4a347af9c7bd13",
            "username": "user@avaya.com",
            "displayname": "Username",
            "picture_url":"https://storage.googleapis.com/onesna/pictures/pfpic_85c55d13-6f87-42f4-a576-c1a5a87dc150",
            "type":"user"
         },
         "content":{
            "endTime":null,
            "mediaMode":"audio",
            "virtualEndTime":null,
            "meetingStatus":"active",
            "bodyText":"test",
            "assignees":[

            ],
            "description":"",
            "data":[

            ],
            "dueDate":"2020-07-07T18:16:54.212Z",
            "status":"pending",
            "attendees":[

            ],
            "startTime":"2020-07-07T18:16:54.214Z",
            "recordings":[

            ]
         },
         "chatCount":0,
         "likeCount":0,
         "status":0,
         "category":"idea",
         "topicId":"5f04ad69d412076f2d57a4a9",
         "created":"2020-07-07T18:16:54.209Z",
         "modified":"2020-07-07T18:16:54.209Z",
         "__v":0
      }
   ],
   "nextPageUrl":"",
   "previousPageUrl":"",
   "total":1
}`}
        </pre>
      </div>
    </div>
  </Layout>
)
